import "../css/Loader.css";
import React, { useEffect, useState } from 'react';
import { useLoading } from '../utils/ApolloProvider';
import LoaderImg from '../media/images/loader.gif';

const Loader = () => {
  const loading = useLoading();

  return (
    <div key="LOADER" className={`Loader-cont`} style={{ display: loading ? 'flex' : 'none' }}>
      <img loading="lazy" src={LoaderImg} alt="loader" className="Loader-img"/>
    </div>
  );
};

export default Loader;
